var _translations = {};

/**
 * This contains all translatable pixie editor texts
 * (copied from app/Resources/vendor/pixie/translations.json)
 *
 * #########################################
 *
 * Warning: in one specific situation the editor broke because
 * the _messages object below contained the translation key for 'crop', see _initPixie in helper-pixie.js
 */
var _messages = {
    filter: 'Filter',
    resize: 'Resize',
    crop: 'Crop',
    transform: 'Transform',
    draw: 'Draw',
    drawing: 'Drawing',
    text: 'Text',
    shape: 'Shape',
    shapes: 'Shapes',
    sticker: 'Sticker',
    stickers: 'Stickers',
    frame: 'Frame',
    corners: 'Corners',
    background: 'Background',
    merge: 'Merge',
    History: 'History',
    Objects: 'Objects',
    image: 'Image',
    mainImage: 'Main Image',
    'Canvas Background': 'Canvas Background',
    Width: 'Width',
    Height: 'Height',
    'Brush Color': 'Brush Color',
    'Brush Type': 'Brush Type',
    'Brush Size': 'Brush Size',
    Cancel: 'Cancel',
    Close: 'Close',
    Apply: 'Apply',
    Size: 'Size',
    'Maintain Aspect Ratio': 'Maintain Aspect Ratio',
    'Use Percentages': 'Use Percentages',
    Radius: 'Radius',
    'Align Text': 'Align Text',
    'Format Text': 'Format Text',
    'Color Picker': 'Color Picker',
    'Add Text': 'Add Text',
    Font: 'Font',
    Upload: 'Upload',
    'Google Fonts': 'Google Fonts',
    'Search...': 'Search...',
    Shadow: 'Shadow',
    Color: 'Color',
    Outline: 'Outline',
    Background: 'Background',
    Texture: 'Texture',
    Gradient: 'Gradient',
    'Text Style': 'Text Style',
    Delete: 'Delete',
    'Background Color': 'Background Color',
    'Outline Width': 'Outline Width',
    Blur: 'Blur',
    'Offset X': 'Offset X',
    'Offset Y': 'Offset Y',
    Open: 'Open',
    Save: 'Save',
    Zoom: 'Zoom',
    Editor: 'Editor',
    'Applied: filter': 'Applied: filter',
    'Applied: resize': 'Applied: resize',
    'Applied: crop': 'Applied: crop',
    'Applied: transform': 'Applied: transform',
    'Added: drawing': 'Added: drawing',
    'Added: text': 'Added: text',
    'Added: shape': 'Added: shape',
    'Added: sticker': 'Added: sticker',
    'Added: frame': 'Added: frame',
    'Objects: merged': 'Objects: merged',
    'Applied: rounded corners': 'Applied: rounded corners',
    'Changed: background': 'Changed: background',
    'Changed: background image': 'Changed: background image',
    'Added: overlay image': 'Added: overlay image',
    Initial: 'Initial',
    'Loaded: state': 'Loaded: state',
    'Changed: style': 'Changed: style',
    Add: 'Add',
    Fullscreen: 'Fullscreen',
    'Bring to front': 'Bring to front',
    Duplicate: 'Duplicate',
    Flip: 'Flip',
    Custom: 'Custom',
};

var _getTranslations = function () {
    $.each(_messages, function (msgId, msgStr) {
        var translated = Translator.trans(msgStr);

        if (translated !== '') {
            _translations[msgId] = translated;
        }
    });

    return _translations;
};

var translator = {
    getTranslations: _getTranslations,
};

export { translator };
